import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7h-2z"
}), 'KeyboardReturnSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/KeyboardReturnSharp.js
// module id = 4350
// module chunks = 2